import { render, staticRenderFns } from "./buy-member-modal.vue?vue&type=template&id=31944c64&scoped=true&lang=pug&"
import script from "./buy-member-modal.vue?vue&type=script&lang=js&"
export * from "./buy-member-modal.vue?vue&type=script&lang=js&"
import style0 from "./buy-member-modal.vue?vue&type=style&index=0&id=31944c64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31944c64",
  null
  
)

export default component.exports